var render = function render(){var _vm=this,_c=_vm._self._c;return _c('queue-item',{attrs:{"item":_vm.item,"queue-type":"TGDB","queue-id":_vm.item.other_id,"skipped-fields":_vm.SKIPPED_FIELDS,"skipped-fields-if-set":_vm.SKIP_IF_SET_FIELDS,"source-link":_vm.tgdbLink,"save-func":_vm.saveQueueChange,"decline-func":_vm.deleteFromQueue,"remove-from-queue-func":_vm.deleteFromQueue}})
}
var staticRenderFns = []

export { render, staticRenderFns }